import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { multilanguage } from "redux-multilanguage";
import { Swiper, SwiperSlide } from "swiper/react";
import { addToCart } from "../../../redux/actions/cartActions";
import { addToWishlist } from "../../../redux/actions/wishlistActions";
import { addToCompare } from "../../../redux/actions/compareActions";
import { wfetch } from "../../../utils/fetch";
import { getApiEndpoint } from "../../../utils/constants/api";
import ProductTeaser from "../productTeaser/ProductTeaser";
import SectionTitle from "../sectionTitle/SectionTitle";
import { getProducts } from "../../../services/products.service";
import { SHOP_SOURCES } from "../../../utils/constants/shopSources";

const RelatedProductSlider = ({ currentLanguageCode, categoryId, source, currency, addToCart, addToWishlist, addToCompare }) => {
    const [relatedProducts, setRelatedProducts] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const productNodes = await getProducts({
                lang: currentLanguageCode,
                categoryId,
                source,
                queryParams: { limit: 8, category: source === SHOP_SOURCES.JCR ? categoryId : undefined },
            });

            if (productNodes) setRelatedProducts(productNodes);
        }

        if (categoryId) fetchData();
    }, [currentLanguageCode, categoryId]);

    if (relatedProducts.length === 0) return;

    return (
        <div className="related-product-area pb-95">
            <div className="container">
                <SectionTitle titleText="Related Products" positionClass="text-center" spaceClass="mb-50" />

                <div className="row">
                    <Swiper
                        loop={false}
                        slidesPerView={4}
                        grabCursor={true}
                        spaceBetween={30}
                        breakpoints={{
                            1024: {
                                slidesPerView: 4,
                            },
                            768: {
                                slidesPerView: 3,
                            },
                            640: {
                                slidesPerView: 2,
                            },
                            320: {
                                slidesPerView: 1,
                            },
                        }}
                        className="swiper-wrapper"
                    >
                        {relatedProducts &&
                            relatedProducts.map((product) => {
                                return (
                                    <SwiperSlide key={product["@id"]}>
                                        <ProductTeaser
                                            product={product}
                                            currency={currency}
                                            addToCart={addToCart}
                                            addToWishlist={addToWishlist}
                                            addToCompare={addToCompare}
                                        />
                                    </SwiperSlide>
                                );
                            })}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

RelatedProductSlider.propTypes = {
    category: PropTypes.string,
    currency: PropTypes.object,
    addToCart: PropTypes.func,
    addToWishlist: PropTypes.func,
    addToCompare: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        currency: state.currencyData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (item) => {
            dispatch(addToCart(item));
        },
        addToWishlist: (item) => {
            dispatch(addToWishlist(item));
        },
        addToCompare: (item) => {
            dispatch(addToCompare(item));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(multilanguage(RelatedProductSlider));
